module.exports = __webpack_public_path__ + "img/counter_n.3696ea9b.png";